import { render, staticRenderFns } from "./AuditLogQuery.vue?vue&type=template&id=60768fc4&"
import script from "./AuditLogQuery.vue?vue&type=script&lang=ts&"
export * from "./AuditLogQuery.vue?vue&type=script&lang=ts&"
import style0 from "./AuditLogQuery.vue?vue&type=style&index=0&id=60768fc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports